import React, { useEffect, useState } from "react";

import FaqData from "../../components/data/Faq.json"


const FaqComponent = ({ location }) => {
  const [show, setShow] = useState(false);


  const [viewAnswer , setViewAnswer] = useState(false)


  const data1 = "data1";
  const data2 = "data2";

  const [checkLocation, setChecklocation] = useState(null);

  useEffect(() => {
    if (location === "delhi") {
      setChecklocation(data1);
    }
    if (location === "Benguluru") {
      setChecklocation(data2);
    }
  }, []);

  // console.log("FAQ Result ", checkLocation);

  return (
    <div>
      <div className="faq">
        <div>
          <div className="faq-heading faq-location-heading">
            FREQUENTLY ASKED QUESTIONS{" "}
          </div>

      

          <div className="Faq-location-home">
            <div className="Faq-location-content">


              {

                  FaqData&& FaqData.map((e ,i)=>(

                 <div className="Faq-location-content-row">
                <div className="Faq-location-questions" onClick={()=>setViewAnswer( viewAnswer === i ? null: i)}>
               Q{i+1}. {e.questions}


                  {

                      viewAnswer === i ?

                      <i class="fa-solid fa-minus"></i>
                      :
                      <i class="fa-solid fa-plus"></i>
                    
                  }

                </div>

                {

                  viewAnswer === i ?

                  <div className="Faq-location-answer"> Ans: {e.answer} </div>
                  :""
                }
              </div>
                  ))
                  
              }
          
            </div>
          </div>
          

          <a href="#services" className="landing-page-button-web-yellow">
            Book Service Now
          </a>

          <a href="#services" className="landing-page-button-mobile-yellow">
            Book Service Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default FaqComponent;
